<template>
  <div id="app">
    <!-- <div class="assistant__box">
      <div class="container__box">
        <div class="assistant__login--box">
          <q-btn v-if="assistant.show" v-for="assistant in assistantList" key="assistant.label" @click="assistant.click" flat no-caps dense text-color="grey-1" :padding="assistant.padding" :label="assistant.label" />
        </div>
      </div>
    </div> -->
    <div class="header__box" id="headNav" :class="{'fixedNav':fixedNav}">
      <div class="container__box">
        <!-- <div class="header__qrcode__box qrcode__box">
          <div class="header__qrcode__box--thumb">
            <img src="./assets/images/minicode.png" alt="">
            <div class="header__qrcode__box--desc">{{$t("followMiniPrograms")}}</div>
          </div>
          <div class="header__qrcode__box--thumb">
            <img src="./assets/images/companycode.png" alt="">
            <div class="header__qrcode__box--desc">{{$t("wechatconsulting")}}</div>
          </div>
          <div class="header__qrcode__box--thumb">
            <img src="./assets/images/bosscode.png" alt="">
            <div class="header__qrcode__box--desc">{{$t("weChatofficialaccount")}}</div>
          </div>
        </div> -->
        <div class="clearfix">
          <div class="logo__box"><img class="logo" src="./assets/images/logo_new.png" width="58px" height="49px" alt="">{{$t("company")}}</div>
          <!-- <div class="assistant__login--box" style="float: right;">
            <q-btn v-if="assistant.show" v-for="assistant in assistantList" key="assistant.label" @click="assistant.click" flat no-caps dense :padding="assistant.padding" :label="assistant.label" />
          </div> -->
          <!-- <template>
            <div class="language">
              <q-btn-dropdown flat dense color="primary" label="中文">
                <q-list>
                  <q-item v-for="assistant in assistantList"  key="assistant.label" clickable v-close-popup @click="assistant.click">
                    <q-item-section>
                      <q-item-label>{{assistant.label}}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-btn-dropdown>
            </div>
          </template>

          <div v-if="userModule.noLoginShow" class="loginorRegister" @click="clickLogin">{{userModule.noLoginLabel}}</div>
          <div v-if="!userModule.noLoginShow" class="loginInfo"><span>{{userModule.mobile}}</span><span @click="loginOut" class="exitBtn">{{userModule.exitOut}}</span></div> -->
          <div class="assistant__login--box">
            <q-btn v-if="assistant.show" v-for="assistant in assistantList" key="assistant.label" @click="assistant.click" flat no-caps dense :padding="assistant.padding" :class="assistant.color" :label="assistant.label" />
          </div>

          <div class="nav__box">
            <ul class="nav__list">
              <li class="nav__item"><router-link to="/">{{$t('nav.HOME')}}</router-link></li>
              <li class="nav__item"><router-link :to="{name:'buy'}">{{$t('nav.BUY')}}</router-link></li>
              <li class="nav__item"><router-link :to="{name:'rentlist'}">{{$t('nav.RENT')}}</router-link></li>
              <li class="nav__item"><router-link :to="{name:'sell'}">{{$t('nav.SELL')}}</router-link></li>
              <li class="nav__item"><router-link :to="{name:'trusteeship'}">{{$t('nav.TRUSTEESHIP')}}</router-link></li>
              <li class="nav__item"><router-link :to="{name:'about'}">{{$t('nav.ABOUT')}}</router-link></li>
              <!--            <li class="nav__item"><router-link to="/calculator">{{$t('nav.CALCULATOR')}}</router-link></li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <router-view :key="componentKey"></router-view>
    <!--  底部  -->
    <div v-if="footer" class="footer">
      <div class="footer_new"> <!---class="container__box"-->
        <h3 class="concat-us">{{$t('about.contact.title2')}}</h3>
        <h3 class="concat-us-en">Contact   Us</h3>
        <p class="email"><i class="el-icon-message"></i>rose@blueoceanboston.com</p>
        <p class="tel"><i class="el-icon-phone"></i>8572077579</p>
        <div class="footer__qrcode__box qrcode__box">
          <div class="footer__qrcode__box--thumb">
            <img src="./assets/images/bosscode.png" alt="">
            <div class="header__qrcode__box--desc">{{$t("weChatofficialaccount")}}</div>
          </div>
          <div class="footer__qrcode__box--thumb">
            <img src="./assets/images/companycode.png" alt="">
            <div class="header__qrcode__box--desc">{{$t("wechatconsulting")}}</div>
          </div>
          <div class="footer__qrcode__box--thumb">
            <img src="./assets/images/minicode.png" alt="">
            <div class="header__qrcode__box--desc">{{$t("followMiniPrograms")}}</div>
          </div>
        </div>        
        <div class="social__box">
          <a href="https://www.facebook.com/blueoceanboston/" target="_blank" class="facebook__link">
            <img src="./assets/images/home/faceBook.png" alt="">
          </a>
          <a target="_blank" href="http://www.youtube.com/channel/UCHHpW1UpTEFK61r5RZaDNrw" class="youtube__link">
            <img src="./assets/images/home/youTob.png" alt="">
          </a>
          <a target="_blank" href="https://www.linkedin.com/in/rose-hall-mpa-2b95a522" class="in__link">
            <img src="./assets/images/home/in.png" alt="">
          </a>
        </div>
        <div class="copyright">
          <p>{{$t('fangchanweb')}} (617) 206-5700   15 North Beacon Street, Suite NR1A, Boston, MA 02134</p>   
          <p>{{$t('copyrightaddress')}}</p>
        </div>
        <div class="row" style="display: none;">
          <div class="col-8 realtor__content">
            <div style="overflow: hidden;">
              <img class="float-left" src="/assets/images/RealtorLogo.png" alt="">
              <p>{{$t('footer.rule')}}</p>
            </div>
            <address class="footer__address">
              <p>{{$t('company')}} (617) 206-5700</p>
              <p>{{$t('footer.address')}}</p>
              <p>{{$t('copyrightaddress')}}</p>
            </address>
            <div class="footer__qrcode__box qrcode__box">
              <div class="footer__qrcode__box--thumb">
                <img src="./assets/images/bosscode.png" alt="">
                <div class="header__qrcode__box--desc">{{$t("weChatofficialaccount")}}</div>
              </div>
              <div class="footer__qrcode__box--thumb">
                <img src="./assets/images/companycode.png" alt="">
                <div class="header__qrcode__box--desc">{{$t("wechatconsulting")}}</div>
              </div>
              <div class="footer__qrcode__box--thumb">
                <img src="./assets/images/minicode.png" alt="">
                <div class="header__qrcode__box--desc">{{$t("followMiniPrograms")}}</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="contact__box">
              <a href="mailto:info@blueoceanboston.com">{{$t('footer.email')}}</a>
            </div>
            <div class="social__box">
              <a href="https://www.facebook.com/blueoceanboston/" target="_blank" class="facebook__link">
                <img src="./assets/images/home/faceBook.png" alt="">
                <!-- <svg t="1615689218780" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2114" width="200" height="200"><path d="M928 0H96A96.256 96.256 0 0 0 0 96v832A96.256 96.256 0 0 0 96 1024H512V576H384v-128h128V384a192.298667 192.298667 0 0 1 192-192h128v128h-128A64 64 0 0 0 640 384v64h192l-32 128H640V1024h288A96.256 96.256 0 0 0 1024 928V96A96.256 96.256 0 0 0 928 0z" p-id="2115"></path></svg> -->
              </a>
              <a target="_blank" href="http://www.youtube.com/channel/UCHHpW1UpTEFK61r5RZaDNrw" class="youtube__link">
                <img src="./assets/images/home/youTob.png" alt="">
                <!-- <svg t="1615689259081" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2874" width="200" height="200"><path d="M628.004571 710.838857v120.576c0 25.709714-7.424 38.290286-22.272 38.290286-8.557714 0-17.152-3.986286-25.709714-12.580572v-171.995428c8.557714-8.557714 17.152-12.580571 25.709714-12.580572 14.848 0 22.272 13.129143 22.272 38.290286z m193.133715 0.585143v26.294857h-51.419429v-26.294857c0-25.709714 8.557714-38.838857 25.709714-38.838857s25.709714 13.129143 25.709715 38.838857zM269.129143 586.861714h61.147428v-53.723428H151.990857v53.723428h60.013714v325.156572H269.165714v-325.156572z m164.571428 325.156572h50.870858v-282.294857H433.700571v215.990857c-11.446857 16.018286-22.272 23.990857-32.585142 23.990857-6.838857 0-10.861714-3.986286-11.995429-11.995429-0.585143-1.718857-0.585143-8.009143-0.585143-20.004571v-208.018286H337.664v223.414857c0 20.004571 1.718857 33.133714 4.571429 41.728 4.571429 14.299429 16.566857 21.138286 33.133714 21.138286 18.285714 0 37.705143-11.446857 58.294857-34.852571v30.866285z m245.138286-84.589715v-112.566857c0-26.294857-1.133714-45.129143-5.156571-56.576-6.290286-21.138286-20.553143-32-40.557715-32-18.870857 0-36.571429 10.276571-53.138285 30.866286v-124.013714h-50.870857v378.843428h50.870857v-27.428571c17.152 21.138286 34.852571 31.414857 53.138285 31.414857 20.004571 0 34.304-10.861714 40.557715-31.414857 3.986286-11.995429 5.156571-30.866286 5.156571-57.161143z m193.170286-5.705142v-7.424h-52.004572c0 20.553143-0.585143 32-1.133714 34.852571-2.852571 13.714286-10.276571 20.553143-22.857143 20.553143-17.700571 0-26.294857-13.129143-26.294857-39.424v-49.700572h102.290286v-58.843428c0-30.281143-5.156571-52.004571-15.433143-66.304-14.848-19.419429-34.852571-29.147429-60.562286-29.147429-26.294857 0-46.299429 9.728-61.147428 29.147429-10.861714 14.299429-16.018286 35.986286-16.018286 66.304v98.852571c0 30.281143 5.705143 52.553143 16.566857 66.304 14.848 19.419429 34.852571 29.147429 61.696 29.147429s48.018286-10.276571 61.696-30.281143a65.828571 65.828571 0 0 0 11.995429-30.866286c1.133714-5.156571 1.133714-16.566857 1.133714-33.133714z m-347.428572-521.728V180.004571c0-26.294857-7.424-39.424-24.576-39.424-16.566857 0-24.576 13.129143-24.576 39.424v119.990858c0 26.294857 8.009143 40.009143 24.576 40.009142 17.152 0 24.576-13.714286 24.576-40.009142z m410.843429 429.165714c0 65.718857-0.585143 136.009143-14.848 200.009143-10.861714 45.129143-47.433143 78.299429-91.428571 82.870857-105.142857 11.995429-211.419429 11.995429-317.147429 11.995428s-212.004571 0-317.147429-11.995428c-43.995429-4.571429-81.152-37.705143-91.428571-82.870857-14.848-64-14.848-134.290286-14.848-200.009143 0-66.304 0.585143-136.009143 14.848-200.009143 10.861714-45.129143 47.433143-78.299429 92.013714-83.419429 104.557714-11.446857 210.870857-11.446857 316.562286-11.446857s212.004571 0 317.147429 11.446857c43.995429 5.156571 81.152 38.290286 91.428571 83.419429 14.848 64 14.848 133.705143 14.848 200.009143zM365.129143 0h58.294857L354.267429 227.986286v154.843428H297.106286V227.986286c-5.156571-28.013714-16.566857-67.986286-34.852572-121.161143-12.580571-35.437714-25.161143-71.424-37.156571-106.861714h60.562286L326.217143 150.235429z m211.456 190.281143v99.986286c0 30.281143-5.156571 53.138286-16.018286 67.437714-14.299429 19.419429-34.304 29.147429-60.562286 29.147428-25.709714 0-45.714286-9.728-60.013714-29.147428-10.861714-14.848-16.018286-37.156571-16.018286-67.437714V190.281143c0-30.281143 5.156571-52.553143 16.018286-66.852572 14.299429-19.419429 34.304-29.147429 60.013714-29.147428 26.294857 0 46.299429 9.728 60.562286 29.147428 10.861714 14.299429 16.018286 36.571429 16.018286 66.852572zM768 97.718857v285.147429h-52.004571V351.451429c-20.553143 23.990857-40.009143 35.437714-58.843429 35.437714-16.566857 0-28.562286-6.838857-33.718857-21.138286-2.852571-8.557714-4.571429-22.272-4.571429-42.861714V97.755429h52.004572v209.700571c0 11.995429 0 18.870857 0.585143 20.004571 1.133714 8.009143 5.156571 12.580571 11.995428 12.580572 10.276571 0 21.138286-8.009143 32.585143-24.576V97.755429h52.004571z" p-id="2875"></path></svg> -->
              </a>
              <a target="_blank" href="https://www.linkedin.com/in/rose-hall-mpa-2b95a522" class="in__link">
                <img src="./assets/images/home/in.png" alt="">
                <!-- <svg t="1615689285127" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3632" width="200" height="200"><path d="M946.2784 0C966.656 0 984.6784 6.9632 1000.448 20.7872 1016.1152 34.7136 1024 51.8144 1024 72.192l0 876.9536c0 20.3776-7.8848 37.4784-23.552 51.3024C984.6784 1014.272 966.656 1021.2352 946.2784 1021.2352L74.9568 1021.2352c-20.3776 0-37.888-6.9632-52.736-20.7872C7.3728 986.5216 0 969.5232 0 949.0432L0 72.192c0-20.3776 7.3728-37.4784 22.2208-51.3024S54.5792 0 74.9568 0L946.2784 0zM227.5328 316.3136c24.064 0 44.8512-8.704 62.464-26.4192 17.6128-17.6128 26.4192-38.4 26.4192-62.464 0-23.9616-8.8064-44.8512-26.4192-62.464C272.384 147.5584 251.5968 138.752 227.5328 138.752c-24.064 0-44.8512 8.8064-62.464 26.3168-17.6128 17.6128-26.4192 38.4-26.4192 62.464 0 25.9072 8.2944 47.2064 24.9856 63.7952C180.4288 308.0192 201.6256 316.3136 227.5328 316.3136zM302.4896 871.3216 302.4896 382.976 152.6784 382.976l0 488.448L302.4896 871.424zM871.3216 871.3216 871.3216 602.2144c0-73.9328-12.4928-130.8672-37.4784-170.7008C808.96 391.7824 761.2416 371.8144 690.9952 371.8144c-70.3488 0-118.3744 25.9072-144.2816 77.7216L543.9488 449.536 543.9488 382.976 399.5648 382.976l0 488.448 149.8112 0L549.376 629.9648c0-83.2512 30.5152-124.928 91.5456-124.928 24.064 0 42.0864 7.8848 54.0672 23.552 11.9808 15.7696 18.944 30.5152 20.7872 44.4416s2.7648 33.792 2.7648 59.6992l0 238.6944L871.3216 871.424z" p-id="3633"></path></svg> -->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <q-dialog v-model="contact.status">
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">{{$t('about.contact.title2')}}</div>
        </q-card-section>
        <q-card-section>
          <form @submit.prevent="simulateSubmit" class="w500">
            <q-input outlined v-model="contact.form.userName" class="mt10" :label="$t('about.contact.Name')" />
            <q-input outlined v-model="contact.form.email" class="mt10" :label="$t('about.contact.Email')" />
            <q-input outlined v-model="contact.form.mobile"  class="mt10" :label="$t('about.contact.Phone')" />
            <q-input outlined v-model="contact.form.weixinNo"  class="mt10" :label="$t('about.contact.Wechat')" />
            <q-input type="textarea" class="mt10" outlined v-model="contact.form.question" :label="$t('about.contact.questions')" />
            <q-btn :loading="contact.submitting" type="submit" style="width: 100%" color="secondary" class="mt10" :label="$t('about.contact.Send')">
              <template v-slot:loading>
                <q-spinner-facebook />
              </template>
            </q-btn>
          </form>
        </q-card-section>
      </q-card>
    </q-dialog>
    <!-- <q-layout style="min-height: 0">
      <q-page-sticky position="bottom-right" :offset="[ 18, 18 ]" class="z-top">
        <q-fab color="cyan-5" icon="keyboard_arrow_left" direction="left">
          <q-fab-action color="primary" @click="showContactDialog" icon="message" />
          <q-fab-action color="secondary" icon="phone" :label="$t('tel')" />
          <q-fab-action color="deep-orange-10" icon="email" :label="$t('email')" />
        </q-fab>
      </q-page-sticky>
    </q-layout> -->
    <!-- <q-layout style="min-height: 0">
      <q-page-sticky position="bottom-right" :offset="[ 18, 100 ]" class="z-3000">
        <q-fab
          disable
          color="purple"
          icon="keyboard_arrow_up"
          direction="up"
          glossy
          v-model="infoStatus"
        >
          <q-fab-action @click="rentTooltipClick" color="secondary" :label= "$t('blog.rent.title')"></q-fab-action>
          <q-fab-action @click="tgTooltipClick" color="secondary" :label="$t('blog.tg.title')">
          </q-fab-action>
          <q-fab-action @click="saleTooltipClick" color="secondary" :label="$t('blog.sale.title')">
          </q-fab-action>
          <q-fab-action @click="buyTooltipClick" color="primary" :label="$t('blog.buy.title')">
          </q-fab-action>
        </q-fab>
      </q-page-sticky>
    </q-layout> -->
    
    <q-dialog v-model="login.status">
      <q-card>
        <q-card-section horizontal>
          <q-card-section class="bg-teal-1 text-center login__qrcode--box">
            <img width="200" src="./assets/images/minicode.png">
          </q-card-section>
          <q-card-actions class="w300 q-pa-md">
            <q-form
              class="q-gutter-md"
              @submit="onLoginSubmit"
            >
              <q-input
                ref="mobile"
                filled
                v-model="login.mobile"
                :label="$t('login.mobile')"
                :rules="[ val => val && val.length > 0 || $t('login.typeMobileTip')]"
              />
              <q-input
                ref="captcha"
                filled
                v-model="login.captcha"
                :label="$t('login.captcha')"
                :rules="[
                val => val !== null && val !== '' || $t('login.typeCodeTip')
              ]"
              >
                <template v-slot:append>
                  <q-btn dense :disable="send.disable" @click="sendCode" flat :label="send.label" />
                </template>
              </q-input>
              <div>
                <q-btn label="Submit" type="submit" color="primary" style="width: 100%"/>
              </div>
            </q-form>
          </q-card-actions>
        </q-card-section>
      </q-card>
    </q-dialog>


    <!-- <el-dialog
      title=""
      :show-close="false"
      :visible.sync="login.status"
      custom-class="login-dialog-module"
      width="600px">
      <h3 class="login_title">创建一个账号</h3>
      <div class="form-module">
        <el-form :model="login" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="" prop="mobile">
            <el-input ref="mobile" v-model="login.mobile">
              <el-select style="width: 132px;" v-model="countrySelect" slot="prepend" placeholder="请选择">
                <el-option label="中国 （+86）" value="86"></el-option>
                <el-option label="美国 （+01）" value="01"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="captcha">
            <el-input ref="captcha" v-model="login.captcha">
              <el-button slot="append" size="mini" :disable="send.disable" @click="sendCode">{{send.label}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;" @click="onLoginSubmit('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
        <p class="bottom-hint">登录同创建</p>
      </div>
    </el-dialog> -->

    <!---页面右侧固定条--->
    <div class="fixedBox" v-if="showFixed">
      <div class="customer-img">
        <div class="two">
          <div class="three">
            <div class="avtor-img"></div>
          </div>
        </div>
      </div>
      <p class="zixuan" style="padding-bottom: 10px;">{{$t('wconsolt')}}</p>
      <p class="zixuan"><i class="el-icon-phone"></i>8572077579</p>
      <p class="zixuan"><i class="el-icon-message"></i>rose@blueo</p>
      <p>ceanboston.com</p>
      <div>
        <p class="img"><img src="./assets/images/home/wx.png" height="80px" width="80px" alt="微信咨询"></p>
        <p class="name">{{$t('wxzy')}}</p>
        <p class="img"><img src="./assets/images/home/gzh.png" height="80px" width="80px"  alt="关注公众号"></p>
        <p class="name">{{$t('gzgzh')}}</p>
        <p class="img"><img src="./assets/images/home/xcx.png" height="80px" width="80px"  alt="关注小程序"></p>
        <p class="name">{{$t('gzxcx')}}</p>
        <div class="backUp" @click="backTopWindow">{{$t('backTop')}}</div>
      </div>
      <div class="closeBtn" @click="showFixed = false">X</div>
    </div>
    
    <div v-if="!showFixed" @click="showFixed = true" class="fixedOpen"><i class="el-icon-d-arrow-left"></i></div>
  </div>
</template>

<style lang="scss">
  
  .login-dialog-module{
    border-radius: 30px;
  }
  #app{
    .language{
      float: right;
      margin-left: 10px;
      height: 28px;
      vertical-align: top;
      margin-top: 9px;
      button{
        height: 28px;
        vertical-align: top;
      }
    }
    .login_title{
      color: #443227;
      height: 44px;
      line-height: 44px;
      text-align: center;
      margin-bottom: 40px;
    }
    .form-module{
      width: 400px;
      margin: 0 auto;
    }
    .bottom-hint{
      color: #A6A6A6;
      height: 22px;
      line-height: 22px;
      text-align: center;

    }
    .phouse__search--filterbox{
      /* background-color: #f5f5f6; */
      background-color: #fff;
      line-height: 1;
      padding: 10px 15px;
      min-height: 100px;
      .h40{
        height: 40px;
      }
      .phouse__search--filterlist{
        margin-top: 15px;
        .q-btn{
          margin: 0 5px;
        }
      }
      .search__form{
        margin: 0;
        .search__input{
          height: 45px;
          font-size: 14px;
        }
        .search__btn{
          margin-top: 10px;
          vertical-align: -6px;
        }
      }
      .phouse__search--filter--item--requirement{
        color: #101d37;
        font-size: 10px;
        margin-left: 110px;
      }
      .phouse__search--filter--item--requirement a{display: inline-block;margin: 0 5px;color: #101d37;}
      .phouse__search--filter--item--requirement a:hover{text-decoration: underline;}
      .phouse__search--filter--item--requirement label{margin-right: 15px;}
      .phouse__search--filter--item--requirement label input{vertical-align: -2px;margin-right: 5px;}
    }
    .phouse__view{
      height: calc(100% - 60px);
      .phouse__map{
        width: 55%;
        height: 100%;
        float:right;
        .vue-map-container{
          height: 100%;
        }
      }

      .phouse__list{
        float: left;
        width: 45%;
        height: 100%;
        box-shadow: 0 0px 16px -2px #909090;
        position: relative;
        z-index: 1;
        ul{
          padding: 0 16px;
          height: calc(100% - 58px);
          overflow-y: auto;
          &::-webkit-scrollbar{width: 10px;height: 1px;}
          &::-webkit-scrollbar-thumb{ border-radius: 10px;background: #666;}
          &::-webkit-scrollbar-track { border-radius: 10px;background: #ccc;}
          .list__nodata{
            font-size: 18px;
            line-height: 28px;
            font-family: "Ivar Headline", "Ivar Headline Subset", "Times New Roman", serif;
            padding: 20px;
          }
        }
      }
      .phouse__list--tabs{
        border-bottom: 1px solid #ccc;
      }
      .phouse__item{border-bottom: 1px solid #f1f1f1;padding: 10px 10px 10px 200px;cursor: pointer;}
      .phouse__item--thumb{
        position: relative;
        float: left;
        width: 188px;
        height: 126px;
        margin-left: -200px;
        .phouse__item--collect{
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .phouse__item--thumb img{width: 100%;height: 100%;}
      .phouse__item--info{padding-top: 8px;padding-right: 100px;
        text-align: left;}
      .phouse__item--desc{font-size: 12px;}
      .phouse__item--info--column{margin-top: 12px;}
      .phouse__item--info--name{font-size: 16px;font-family: false;font-weight: 600;color: #1871FF;
        line-height: 1;}
      .phouse__item--info--icon{display: inline-block;width: 15px;height: 15px;vertical-align: -3px;margin-right: 3px;font-size: 16px;color: #666;}
      .phouse__item--info--icon-i{width: 15px;height: 15px;color: #666;stroke: currentColor;fill: currentColor;}
      .phouse__item--info--content{color: #616669;}
      .phouse__item--info--listing .phouse__item--info--icon{vertical-align: -3px;}
      .phouse__item--info--listing .phouse__item--info--icon-i{width: 14px;height: 14px;}
      .phouse__item--price__box{float: right;margin-right: -100px;margin-top: 50px;font-size: 16px;color: #db4c3f; font-weight: 600;}
    }
    .page__content--box{
      font-family: "Ivar Headline", "Ivar Headline Subset", "Times New Roman", serif;
      margin: 0 auto;
      overflow: hidden;
      .page__content--title{
        font-size: 40px;
        text-align: center;
        font-weight: bold;
        text-align:left;
        line-height:60px;
      }
      .page__content_img{
        width: 590px;
        height: 400px;
        background: url('./assets/images/home/aboutUs.jpg') no-repeat center top;
        overflow: hidden;
        float: left;
        background-size: cover;
      }
      .page__content--section{
        margin-top: 20px;
        width: 570px;
        float: right;
        /* flex: 1; */
        p{
          line-height: 28px;
          font-size: 18px;
          margin-bottom: 15px;
        }
        .seeMore{
          color: #1871FF;
          font-size: 22px;
          cursor: pointer;
          padding-top: 10px;
        }
        h5{
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 10px;
        }
      }
    }
    .infowindow__box--image{
      width:140px;
      height: 140px;
      max-width: 140px;
      max-height: 140px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-content: center;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
    .infowindow__box--name{
      text-align: center;
      font-size: 20px;
      margin-top: 7px;
    }
    .phouse__copyrighttext{
      font-size: 18px;
      line-height: 28px;
      font-family: "Ivar Headline", "Ivar Headline Subset", "Times New Roman", serif;
      padding: 20px;
    }
    .footer__column--box{
      .page__content--box{
        display: flex;
        padding-left: 50px;
        padding-right: 50px;
        .page__content--title{
          width: 200px;
          align-self: center;
        }
      }
    }
    .body__column--box{
      background: #fff;
    }
    .swiper-slide{
      height: 825px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .search__box{
      position: absolute;
      left:50%;
      transform: translate(-50%,-50%);
      bottom: 68px;
      width: 500px;
      height: 70px;
      z-index: 1;
      /* height: 70px; */
      width: 500px;
      color: #E5E5E5;
      font-size: 24px;
      .el-icon-search{
        position: absolute;
        font-size: 30px;
        right: 30px;
        top: 20px;
      }
      .el-select{
        height: 70px;
        width: 100%;
        .el-input.el-input--suffix{
          height: 100%;
          border-radius: 35px;
          overflow: hidden;
        }
        input{
          background: rgba(0, 0, 0, 0.3);
          padding:0 60px 0 30px;
          width: 410px;
          box-sizing: content-box;
          height: 100%;
          border: none;
          color: #fff;
          font-size: 18px;
        }
      }
    }
    .search__box_new{
      position: absolute;
      top:340px;
      left:24%;
      transform: translate(-50%,-50%);
      z-index: 1;
      color: #E5E5E5;
      font-size: 24px;
      .el-icon-search{
        position: absolute;
        font-size: 30px;
        right: 60px;
        top: 20px;
        color:#1871FF;
      }
      .el-select{
        height: 70px;
        width: 500px;
        .el-input.el-input--suffix{
          height: 100%;
          border-radius: 35px;
          overflow: hidden;
        }
        input{
          background: rgba(255, 255, 255, 0.8);
          padding:0 60px 0 30px;
          width: 410px;
          box-sizing: content-box;
          height: 100%;
          border: none;
          color: #A6A6A6;
          font-size: 18px;
        }
      }
    }
    .slogan__title{
      margin-bottom: 80px;
      font-size: 60px;
      color: #fff;
    }
    /*焦点图*/
    .banner__box{position: relative;}
    .focus__box{ position: relative; }
    .focus__list{ position: relative;height: 500px;overflow: hidden; }
    .focus__item{ position: absolute;left: 0;top: 0;width: 100%; opacity: 0;}
    .focus__item img{ width: 100%; }
    .focus__point{position: absolute;bottom: 20px;left: 50%;transform: translateX(-50%);}
    .focus__point--item{display: inline-block;width: 15px;height: 15px;border-radius: 100%;background: #666;margin: 0 5px;}
    .focus__point--item--active,.focus__point--item:hover{background: #bbb;}
    /*底部*/
    .footer{
      padding: 15px 70px 0;
      background: #423B3E;
      position: relative;
      height: 280px;
      box-sizing: content-box;
    }
    .footer__companyname{color: #4599d1;font-size: 32px;font-family: false;font-weight: 200;vertical-align: 16px;
      margin-left: 10px;}
    .footer__disclaimer{text-align: center;font-size: 10px;color: #54545A;width: 600px;margin: 0 auto;line-height: 18px;font-weight: 400;line-height: 16px;}
    .realtor__content{
      img{
        max-width: 100px;
        max-height: 100px;
        margin-right: 20px;
      }
      p{
        line-height: 1.9;
        color: #fff;
        padding: 3px 0;
      }
      .footer__address{
        font-style: normal;
        margin-top: 15px;
        p{
          color: #adadad;
          font-size: 16px;
        }
      }
    }
    .contact__box{
      padding-top: 100px;
      font-size: 18px;
      text-align: right;
      a{
        color: #0197ae;
      }
    }
    .social__box{
      margin-top: 20px;
      text-align: left;
      a{
        margin-right: 20px;
        img{
          height: 40px;
          width: 40px;
          background-size: contain;
          border-radius: 5px;
          overflow: hidden;
        }
        .icon{
          fill: #fff;
          width:40px;
          height: 40px;
        }
        &:hover{
          opacity: .8;
          .icon{
            fill: #ccc;
          }
        }
      }
    }
    .qrcode__box{
      height: 150px;
      img{
        height: 100%;
        margin-left: 10px;
        margin-right: 10px;
      }
    }
    .header__qrcode__box{
      overflow: hidden;
      .header__qrcode__box--thumb{
        height: 100%;
        float: right;
        margin-left: 20px;
        img{
          height: 130px;
        }
        .header__qrcode__box--desc{
          font-size: 12px;
          text-align: center;
          margin-top: 5px;
        }
      }
    }
    .footer__qrcode__box{
      height: 182px;
      float: right;
      overflow: hidden;
      position: absolute;
      right: 46px;
      bottom: 50px;
      .footer__qrcode__box--thumb{
        float: left;
        height: inherit;
        text-align: center;
        margin-right: 20px;
        .header__qrcode__box--desc{
          color: #fff;
          margin-top: 5px;
          font-size: 12px;
        }
      }
      img{
        width: 140px;
        overflow: hidden;
        height: 140px;
        margin-left: 0;
        margin-right: 0;
        border-radius: 5px;
      }
    }
  }
  .assistant__login--box{
    position: relative;
    margin-left: 10px;
    font-size: 18px;
    float: right;
    color: #2a2a33;
    font-weight: 200;
    span{
      color: #2a2a33;
      font-weight: 200;
      font-size:18px
    }
    ::v-deep .q-btn{
      font-size: 18px;
      color: #2a2a33;
      font-weight: 200;
    }
    ::v-deep .q-btn.blue span{
      color: #1871FF !important;
    }
  }
  /* .assistant__login--box::before{
    content: "";
    position: absolute;
    left: 0;
    height: 20px;
    width: 2px;
    top:15px;
    background: #A6A6A6;
  } */
  .more__box{
    width: 300px;
    padding: 15px;
    .more__column{
      margin-bottom: 20px;
      .more__column--header{
        margin-bottom: 10px;
      }
      .more__column--body{
        .q-list{
          .q-item{
            min-height: 30px;
          }
        }
      }
    }

  }
  .filter__select--box{
    min-width: 170px;
    height: 40px;
  }
  .filter__dropdown--box{
    .q-btn__wrapper:before{
      border-color: rgba(0, 0, 0, 0.24);
    }
  }
  .login__qrcode--box{
    display: grid;
    align-items: center;
    img{
      display: inline-block;
      background: #fff;
      padding: 10px;
      box-sizing: border-box;
    }
  }
  .footer_new{
    position: relative;
    color: #fff;
    height: 100%;
    .concat-us{
      font-size: 30px;
      height:40px;
      line-height:40px;
    }
    .concat-us-en{
      font-size: 20px;
      height:40px;
      line-height:40px;
      margin-bottom: 10px;
    }
    .email,.tel{
      font-size: 20px;
      line-height: 36px;
      font-weight: 400;
      i{
        font-size: 20px;
        color: #fff;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .copyright{
      position: absolute;
      bottom: 0;
      line-height: 22px;
      font-size: 14px;
      text-align: center;
      left: 50%;
      transform: translateX(-50%);
    }
  }  
  .fixedBox{
    width: 126px;
    background-color: #fff;
    border: 1px solid rgba(229, 229, 229, 1);
    border-radius: 60px 60px 0 0;
    position: fixed;
    right: 1px;
    bottom: 100px;
    z-index: 999;
    text-align: center;
    .customer-img{
      height: 110px;
      width:110px;
      margin: 18px auto 10px;
      border-radius:110px;
      background:url('./assets/images/home/three.png') no-repeat;
      overflow:hidden;
      .two{
        height: 95px;
        width:95px;
        border-radius:95px;
        margin: 8px auto;
        background:url('./assets/images/home/two.png') no-repeat;
        overflow:hidden;
      }
      .three{
        height: 80px;
        width:80px;
        border-radius:80px;
        margin: 9px;
        background:url('./assets/images/home/one.png') no-repeat;
        overflow:hidden;
      }
      .avtor-img{
        height: 70px;
        width:70px;
        border-radius:70px;
        margin: 3px 4px;
        background:url('./assets/images/home/avtor.png') no-repeat top center;
        overflow:hidden;
        background-size: cover;
      }
    }
    p{
      color: #A6A6A6;
      font-size:12px;
      text-align:center;
    }
    .img{
      margin-top: 12px;
    }
    .name{
      line-height: 25px;
    }
    .backUp{
      cursor: pointer;
      color: #808080;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      border-top: 1px solid rgba(229, 229, 229, 1);
    }
    .zixuan{
      line-height: 18px;
      i{
        font-size: 14px;
        vertical-align: middle;
        padding-right:3px;
      }
    }
    .closeBtn{
      height: 54px;
      width: 54px;
      overflow: hidden;
      border-radius: 28px;
      background-color: rgba(0, 0, 0, 0.1);
      margin:0 auto -55px;
      cursor: pointer;
      font-size: 24px;
      color: #fff;
      line-height: 54px;
    }
  }
  .fixedOpen{
    position: fixed;
    z-index: 999;
    right: 0;
    bottom: 100px;
    font-size: 18px;
    height: 50px;
    width: 50px;
    background-color: #fff;
    color: #1871FF;
    line-height: 50px;
    text-align: center;
  }
  .nav__box li a.router-link-exact-active{
    color: #1871FF;
    font-weight: 600;
  }
  .loginorRegister{
    float: right;
    width: 100px;
    font-size: 12px;
    height: 30px;
    color: #1871FF;
    border: 1px solid #1871FF;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    vertical-align: top;
    margin-top: 8px;
    cursor: pointer;
  }
  .loginInfo{
    float: right;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: #1871FF;
    vertical-align: top;
    margin-top: 10px;
    span{
      padding: 0 5px;
    }
    span.exitBtn{
      cursor: pointer;
    }
  }
</style>

<script>
  import suspension from "./components/suspension"
  import Cookies from 'js-cookie';
  export default {
    components:{
      suspension:suspension
    },
    data(){
      let _this = this;
      return {        
        countrySelect:'86',
        showFixed:true,
        userModule:{
          noLoginLabel:this.$t('login.label'),
          noLoginShow:true,
          exitOut:this.$t('login.loginOut'),
          mobile:''
        },
        assistantList:[
          {
            label:this.$t('login.label'),
            padding:"0 10px",
            color:'blue',
            click:this.clickLogin.bind(this),
            show:true
          },
          {
            label:"",
            padding:"0 5px",
            color:'blue',
            click:this.user.bind(this),
            show:false
          },
          {
            label:"English",
            padding:"0 5px",
            click:function (){
              window.location.href = "http://www.blueoceanboston.com"
            },
            show:true
          },
          {
            label:this.$t('chinaName'),
            padding:"0 5px",
            click:function (){
              window.location.href = "https://www.bostonfang.com"
            },
            show:true
          },
          {
            label:this.$t('login.loginOut'),
            padding:"0 5px",
            color:'blue',
            click:this.loginOut.bind(this),
            show:false
          }
        ],
        login:{
          status:false,
          mobile:"",
          captcha:""
        },
        send:{
          label:this.$t('login.send'),
          time:60,
          disable:false
        },
        rules: {
          mobile: [
            { required: true, message: this.$t('login.typeMobileTip'), trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: this.$t('login.typeCodeTip'), trigger: 'blur' }
          ],
        },
        infoStatus:true,
        contact:{
          form:{
            type:1,
            userName:"",
            email:"",
            mobile:"",
            weixinNo:"",
            question:""
          },
          submitting:false,
          status:false
        },
        tooltipStyle:{
          fontSize:'14px',
          lineHeight:'24px'
        },
        footer:true,
        fixedNav:false,
        componentKey:0,
        renttooltip:true,
      }
    },
    methods:{
      clickLogin(){
        this.login.status = true;        
        this.$refs.ruleForm.resetFields();
        this.$refs.ruleForm.clearValidate();
      },
      backTopWindow(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      },
      async sendCode(){
        // if(this.login.mobile){
        //   let time = this.send.time;
        //     let _this = this;
        //     let mobile = this.login.mobile;
        //     try{
        //       _this.send.label = "Loading...";
        //       let res = await this.$api.requestSendVerificationCode({
        //         mobile:mobile
        //       });
        //     }catch (e){
        //       _this.send.label = _this.$t('login.send');
        //       return false;
        //     }
        //     this.send.label = this.send.time;
        //     this.send.disable = true;
        //     let timer = setInterval(function (){
        //       if(time === 0){
        //         clearInterval(timer);
        //         _this.send.label = _this.$t('login.send');
        //         _this.send.disable = false;
        //         return false;
        //       }
        //       _this.send.label = --time;
        //     },1000)
        // }else{
        //   this.$message({
        //     message: this.$t('login.typeMobileTip'),
        //     type: 'warning'
        //   });
        // }


        let time = this.send.time;
        let _this = this;
        this.$refs.mobile.validate();
        if(!this.$refs.mobile.hasError){
          let mobile = this.login.mobile;
          try{
            _this.send.label = "Loading...";
            let res = await this.$api.requestSendVerificationCode({
              mobile:mobile
            });
          }catch (e){
            _this.send.label = _this.$t('login.send');
            return false;
          }
          this.send.label = this.send.time;
          this.send.disable = true;
          let timer = setInterval(function (){
            if(time === 0){
              clearInterval(timer);
              _this.send.label = _this.$t('login.send');
              _this.send.disable = false;
              return false;
            }
            _this.send.label = --time;
          },1000)
        }
      },
      async onLoginSubmit(){
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
        //     this.$api.requestMobileLogin({
        //       mobile:this.login.mobile,
        //       verificationCode:this.login.captcha
        //     }).then(res =>{
        //       let data = res.data;
        //       if(data){
        //         localStorage.setItem("userInfo",JSON.stringify(data));
        //         let mobile = data.mobile;
        //         let JSESSIONID = data.jSESSIONID;
        //         Cookies.set("JSESSIONID",JSESSIONID);
        //         this.userModule.mobile = mobile
        //         this.userModule.noLoginShow = false

        //         this.assistantList[0].show = false;
        //         this.assistantList[1].label = mobile;
        //         this.assistantList[1].show = true;
        //         this.assistantList[4].show = true;
        //         this.login.status = false;
        //       }
        //     })
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // });

        let res = await this.$api.requestMobileLogin({
          mobile:this.login.mobile,
          verificationCode:this.login.captcha
        });
        let data = res.data;
        if(data){
          localStorage.setItem("userInfo",JSON.stringify(data));
          let mobile = data.mobile;
          let JSESSIONID = data.jSESSIONID;
          Cookies.set("JSESSIONID",JSESSIONID);
          // this.userModule.mobile = mobile
          // this.userModule.noLoginShow = false
          this.assistantList[0].show = false;
          this.assistantList[1].label = mobile;
          this.assistantList[1].show = true;
          this.assistantList[4].show = true;
          this.login.status = false;
        }
      },
      user(){
        this.$router.push({name:"buy",query:{action:"favourite"}})
      },
      async requestUserInfo(){
        let res = await this.$api.getUserInfo();
        if(res.data){
          // this.userModule.noLoginShow = false
          // this.userModule.mobile = res.data.mobile
          this.assistantList[0].show = false;
          this.assistantList[1].label = res.data.mobile;
          this.assistantList[1].show = true;
          this.assistantList[4].show = true;
          localStorage.setItem("userInfo",JSON.stringify(res.data))
        }
      },
      async loginOut(){
        let res = await this.$api.requestLoginOut();
        let code = res.code;
        if(code === 1000){
          
          //this.userModule.noLoginShow = true
          
          this.assistantList[0].show = true;
          this.assistantList[1].label = "";
          this.assistantList[1].show = false;
          this.assistantList[4].show = false;
          localStorage.removeItem("userInfo");
        }
      },
      async simulateSubmit(){
        this.submitting = true;
        try {
          let res = await this.$api.requestSendTouch(this.contact.form);
          this.submitting = false;
          if(res.code !== 1000){
            return false;
          }
          let initialData = this.$options.data();
          let contact = initialData.contact.form;
          this.contact.form = contact;
          this.$q.notify({
            message:this.$t("about.contact.SendSuccess"),
            position:"top"
          })
        }catch (e) {
          this.submitting = false;
        }
      },
      showContactDialog(){
        this.contact.status = true;
      },
      rentTooltipClick(){
        this.$q.dialog({
          title: this.$t('blog.rent.title'),
          message: this.$t('blog.rent.content')+ this.tootipTemplate(),
          html: true
        })
      },
      tgTooltipClick(){
        this.$q.dialog({
          title: this.$t('blog.tg.title'),
          message: this.$t('blog.tg.content')+ this.tootipTemplate(),
          html: true
        })
      },
      saleTooltipClick(){
        this.$q.dialog({
          title: this.$t('blog.sale.title'),
          message: this.$t('blog.sale.content')+ this.tootipTemplate(),
          html: true
        })
      },
      buyTooltipClick(){

        this.$q.dialog({
          title: this.$t('blog.buy.title'),
          message: this.$t('blog.buy.content') + this.tootipTemplate(),
          html: true
        })
      },
      tootipTemplate(){
        return `
          <div class="sticky__qrcode--box">
          <div class="sticky__qrcode--box--thumb">
            <img src="${require('./assets/images/companycode.png')}" alt="">
            <div class="sticky__qrcode__box--desc">${this.$t('wechatconsulting')}</div>
          </div>
          <div class="sticky__qrcode--box--thumb">
            <img src="${require('./assets/images/bosscode.png')}"" alt="">
            <div class="sticky__qrcode__box--desc">${this.$t('weChatofficialaccount')}</div>
          </div>
        </div>
        `
      }
    },
    created() {
      this.requestUserInfo();

    },
    watch:{
      "$route"(n,o){
        let lang = sessionStorage.getItem("lang");
        if(lang){
          this.$root.$i18n.locale = lang;
        }
        this.footer = n.meta.footer === undefined ? true : false;
        this.fixedNav = n.meta.fixedNav === undefined ? false : true;
      },
      "$root.$i18n.locale"(n,o){
        this.componentKey += 1;
      }
    }
  }
</script>
